import React from 'react';
import api from './api';
import AuthContext from '../hooks/useAuth';
import CustomDataTable from './CustomDataTable';


class Sequences extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      sequences: [],
      modSeqs: [],
      selectedRows: [],
      appt:{},
      updateReqd: false,
    };
  }

  componentDidMount() {
    this.fetchSequences();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.patientCard !== this.props.patientCard ||
      prevProps.filterT !== this.props.filterT
    ) {
      this.fetchSequences();
      
    }
  }

  fetchOnGoingAppt = (patientCard) => {
    if (patientCard) 
    {
      api.get(`${process.env.REACT_APP_URL}/appointments/patient/${patientCard}/today/upcoming/1?_=${new Date().getTime()}`)
      .then(resp2 => {
        console.log("appontment", resp2.data);
        var appt = resp2.data.resultsUTC[0];
        if (appt)
        {
          this.setState({
            appt: appt
          });
          if (appt.status == "inprogress")
          {
           if (this.props.onSeqInProgress) {
              this.props.onSeqInProgress(true);
            }
          }
          else
          {
            if (this.props.onSeqInProgress) {
              this.props.onSeqInProgress(false);
            }
          }
        }
        else
        {
          if (this.props.onSeqInProgress) {
            this.props.onSeqInProgress(false);
          }
        }

      })
      .catch ((err) => alert(err));
    }
  }

  fetchSequences = () => {
    const { patientCard, filterT } = this.props;
    let endpoint = patientCard ? `${patientCard}/type/${filterT}` : `type/${filterT}`;

    api.get(`${process.env.REACT_APP_URL}/sequences/${endpoint}`)
      .then(response => {
        const allSeqs = response.data || [];
        const preselected = allSeqs.filter(r => r.parentId && r.parentId !== '');
        /*
        this.setState({
          sequences: response.data || [],
          modSeqs: [],
          selectedRows: [],
          appt: {}
        });
        */

        this.setState({
          sequences: allSeqs,
          modSeqs: [],
          selectedRows: preselected,  // ✅ Add preselected to selectedRows
          appt: {}
        });

        if (patientCard)
        {
          this.fetchOnGoingAppt(patientCard);
        }
      })
      .catch(err => {
        console.error('Error fetching sequences:', err);
      });
    
  };

mergeModifiedAndSelectedRows = (prevState, updatedRow) => {
  const modSeqsCopy = [...prevState.modSeqs];
  const selectedCopy = [...prevState.selectedRows];
  console.log("modSeqsCopy", modSeqsCopy);
  console.log("selectedCopy", selectedCopy);
  const modIdx = modSeqsCopy.findIndex(r => String(r._id) === String(updatedRow._id));
  if (modIdx >= 0) {
    modSeqsCopy[modIdx] = updatedRow;
  } else {
    modSeqsCopy.push(updatedRow);
  }

  const selIdx = selectedCopy.findIndex(r => String(r._id) === String(updatedRow._id));
  if (selIdx >= 0) {
    selectedCopy[selIdx] = updatedRow;
  } else {
    selectedCopy.push(updatedRow);
  }

  const combinedMap = new Map();
  selectedCopy.forEach(r => combinedMap.set(String(r._id), { ...r }));
  modSeqsCopy.forEach(r => {
    combinedMap.set(String(r._id), { ...combinedMap.get(String(r._id)), ...r });
  });

  const combinedRows = Array.from(combinedMap.values());

   // ✅ Determine if update is required
  const updateReqd =
    updatedRow.therapisttocheck === true ||
    modSeqsCopy.some(r => r.therapisttocheck === true);


  return {
    modSeqs: modSeqsCopy,
    selectedRows: selectedCopy,
    combinedRows,
    updateReqd,
  };
};


updateModifiedRow = (updatedRow) => {
  this.setState(prevState => {
    const {
      modSeqs,
      selectedRows,
      combinedRows,
      updateReqd,
    } = this.mergeModifiedAndSelectedRows(prevState, updatedRow);

    setTimeout(() => {
      if (this.props.onDataChange) {
        this.props.onDataChange({combinedRows, updateReqd});
      }
    }, 0);

    return {
      modSeqs,
      selectedRows,
      updateReqd,      
    };
  });
};

handleCellChange = (key, idx, e) => {
  
  const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
  var updateReqd = false;

  this.setState(prevState => {
    const newRows = [...prevState.sequences];
    const updatedRow = { ...newRows[idx], [key]: value, therapisttocheckkeys: [], therapisttocheck: false };

    console.log("handleCellShange == ", updatedRow.status);

    if (key === "remarks") 
    {
        updatedRow.therapisttocheck = true;
        updateReqd = true;
        updatedRow.therapisttocheckkeys.push(key);
    }
    else 
    {
      if (updatedRow.status == "OnGoing") 
      {
        // only remarks from doctor are allowed 
        window.alert("Sequence is in progress. \n Please make this change after the session is over.");
        return;
      }
      else if (updatedRow.status == "Completed" || updatedRow.status == "Skipped")
      {
         window.alert("Sequence is in progress. \n Please make this change after the session is over.");
         return;
      } 
      else if (updatedRow.status == "notStarted")
      {      
        // allowed
     
        updatedRow.therapisttocheck = true;
        updatedRow.therapisttocheckkeys.push(key);
        updateReqd = true;        
      }
    }
    
    newRows[idx] = updatedRow;

    const {
      modSeqs,
      selectedRows,
      combinedRows
    } = this.mergeModifiedAndSelectedRows(prevState, updatedRow);

    setTimeout(() => {
      if (this.props.onDataChange) {
        this.props.onDataChange({combinedRows, updateReqd});
      }
    }, 0);

    return {
      sequences: newRows,
      modSeqs,
      selectedRows
    };
  });
};


setTextValue = (value, _idx, key) => {    

  this.setState(prevState => {
    const newRows = [...prevState.sequences];
    const idx = newRows.findIndex(r => r._id === prevState.sequences[_idx]._id);
    if (idx < 0) return null;

    const oldVal = newRows[idx][key] || "";
    var updateReqd = true;
    const dateVal = new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    const updatedValue = `${dateVal} : ${value}\n${oldVal}`;

    const updatedRow = {
      ...newRows[idx],
      [key]: updatedValue,
      therapisttocheck: true,
      therapisttocheckkeys: [],
    };
    updatedRow.therapisttocheckkeys.push(key);
    newRows[idx] = updatedRow;

    const {
      modSeqs,
      selectedRows,
      combinedRows
    } = this.mergeModifiedAndSelectedRows(prevState, updatedRow);

    setTimeout(() => {
      if (this.props.onDataChange) {
        this.props.onDataChange({combinedRows, updateReqd});
      }
    }, 0);

    return {
      sequences: newRows,
      modSeqs,
      selectedRows
    };
  });
};

handleSeqChange = (e) => {
  
  const newSelection = e.selectedRows || [];
  const prevSelection = this.state.selectedRows;

  const newIds = new Set(newSelection.map(r => r._id));
  const prevIds = new Set(prevSelection.map(r => r._id));

  // Find added rows (in new but not in previous)
  const added = newSelection.filter(r => !prevIds.has(r._id));

  // Find removed rows (in previous but not in new)
  const removed = prevSelection.filter(r => !newIds.has(r._id));

  console.log("✅ Added Rows:", added);
  console.log("❌ Removed Rows:", removed);

  if (removed && removed.length > 0 && this.state.appt?.status === "inprogress") {
    window.alert("Session is in progress.\n Removing Seq. is not allowed. \n Please Complete/ Skip the ongoing session first.\n");
    return;
  }
  // =================
  const selected = e.selectedRows || [];

  this.setState({ selectedRows: selected }, () => {
    const { selectedRows, modSeqs, updateReqd } = this.state;

    // Merge selected and modified rows
    const combinedMap = new Map();
    selectedRows.forEach(r => combinedMap.set(r._id, r));
    modSeqs.forEach(r => {
      const id = r._id;
      combinedMap.set(id, { ...combinedMap.get(id), ...r });
    });

    const combinedRows = Array.from(combinedMap.values());

    if (this.props.onDataChange) {
      this.props.onDataChange({combinedRows, updateReqd});
    }
  });
};

  prefilledSelectionCriteria = row => {
    const isSelected = this.state.selectedRows.some(r => r._id === row._id);
    const isPreSelected = row && row.parentId && row.parentId !== '';
    return isSelected || isPreSelected;
  };

  render() {
    const { sequences } = this.state;

    const sortedSeqs = sequences.slice().sort((a, b) => {
      const isPreA = a.parentId && a.parentId !== '' ? 0 : 1;
      const isPreB = b.parentId && b.parentId !== '' ? 0 : 1;
      return isPreA - isPreB;
    });

    const columns = [
      { name: 'Name', selector: row => row.name, 
        sortable: true,
        minWidth: '150px'
       },
      {
        name: 'Used In',
        selector: row => Array.isArray(row.stype) ? row.stype.join(', ') : row.stype,
        sortable: true,
        minWidth: '220px'
      },
      {
        name: 'Repetition',
        selector: row => row.repetition,
        cell: row => (
          <input
            type="text"
            className="table-number-input"
            disabled={row.status === 'OnGoing'} 
            value={row.repetition || ''}
            onChange={e =>
              this.handleCellChange('repetition', sequences.findIndex(r => r._id === row._id), e)
            }
          />
        ),
        sortable: true,
        
      },
      {
        name: 'Duration',
        selector: row => row.duration,
        
        cell: row => (
          <input
            type="text"
            className="table-number-input"
            value={row.duration || ''}
            disabled={row.status === 'OnGoing'}
            onChange={e =>
              this.handleCellChange('duration', sequences.findIndex(r => r._id === row._id), e)
            }
          />
        ),
        sortable: true
      },
      {
        name: 'Remarks',
        selector: row => row.remarks,
        cell: (row, idx) => (
          <textarea rows="4" cols="30" 
            value={row.remarks || ''}
            onClick={() => {
                const msg = `Existing remarks:\n${row.remarks || ''}\n\nEnter new remark:`;
                const newVal = window.prompt(msg);
                if (newVal !== null && newVal.trim() !== "") {
                  const idx = this.state.sequences.findIndex(r => r._id === row._id);
                  if (idx >= 0) {
                    this.setTextValue(newVal.trim(), idx, 'remarks');
                  }
                }
              }}
            readOnly
            
          />
        )
      },
    
    ];

    return (
      <div>
        <h4>Sequences</h4>
        {sortedSeqs.length > 0 ? (
          <CustomDataTable
            columns={columns}
            data={sortedSeqs}
            selectableRows={true}
            selectableRowSelected={this.prefilledSelectionCriteria}
            onSelectedRowsChange={this.handleSeqChange}
            paginationPerPage={10}
            disableDeselect={ this.state.appt?.status == "inprogress" ? true: false }  // 🔒 prevent user from unselecting rows
            highlightOnHover
            removeSelectAll={true}
            striped
            responsive
            dense
          />
        ) : (
          <div style={{ marginTop: '10px' }}>No sequences to show</div>
        )}
      </div>
    );
  }
}

export default Sequences;
